import type { EditorAppearance } from '@atlaskit/editor-common/types';
import {
	akEditorFullWidthLayoutWidth,
	akEditorFullPageNarrowBreakout,
	akEditorGutterPadding,
	akEditorGutterPaddingDynamic,
	akEditorGutterPaddingReduced,
} from '@atlaskit/editor-shared-styles';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';


export const calcMaxWidth = (
	containerWidth: number,
	editorAppearance?: EditorAppearance,
): number => {

		const fullPagePadding =
			editorAppearance === 'full-page' &&
			containerWidth <= akEditorFullPageNarrowBreakout &&
			editorExperiment('platform_editor_preview_panel_responsiveness', true, {
				exposure: true,
			})
				? akEditorGutterPaddingReduced
				: akEditorGutterPaddingDynamic();

		const fullWidthPadding =
			editorAppearance === 'full-page' ? fullPagePadding * 2 : akEditorGutterPadding * 2;
		return Math.min(containerWidth - fullWidthPadding, akEditorFullWidthLayoutWidth);
}
